
import React from 'react';
import PreviewBase from './previewbase';
import hljs from 'highlight.js/lib/core';
import xml from 'highlight.js/lib/languages/xml';
//import 'highlight.js/styles/github-dark.css';
import 'highlight.js/styles/base16/dracula.css';

hljs.registerLanguage('xml', xml);

class PreviewTTML extends PreviewBase {

    constructor(props) {
        super(props);
        this.codeRef = React.createRef();
        this.state.renderedCode = "";
    }


componentDidMount() {
    super.componentDidMount();
}

componentDidUpdate(prevProps, prevState) {
    super.componentDidUpdate(prevProps, prevState);

    if (prevState.datas !== this.state.datas) {
        this.updateCode(this.state.datas);
        return;
    }

    if (prevState.renderedCode !== this.state.renderedCode) {
    if (this.codeRef.current) {

        const temporarycode = this.state.renderedCode.replace(
                /(<\/?)style(?=[\s/>])/g,
                '$1style2'
            );

        const result = hljs.highlight(
            temporarycode || "",
            {
                language: 'xml',
                ignoreIllegals: true
            }
        );


        this.codeRef.current.innerHTML = result.value;
        this.codeRef.current.setAttribute('data-highlighted', 'yes');
    }
    }}

    updateCode(code) {
        this.setState({ renderedCode: code || "" });
    }

    setFile(datas) {
        this.setState({ datas });
    }

    componentDidUpdateHighlight() {
        // Non utilisé
    }

    render() {
        const { renderedCode } = this.state;

        if (!renderedCode) {
            return null;
        }

        return (
            <div className="preview_div_ttml">
                <pre>
                    <code
                        ref={this.codeRef}
                        className="language-xml"
                    >
                        
                    </code>
                </pre>
            </div>
        );
    }
}

export default PreviewTTML;
